module.exports = __webpack_public_path__ + "static/media/bki.708e01ac.png";